import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row gap-3 md:gap-5 items-center max-md:w-full" }
const _hoisted_2 = { class: "inline-flex flex-col xl:flex-row text-xs leading-loose text-base-200" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  ref: "progress-bar",
  class: "progress-bar relative inline-block rounded bg-neutral-200 w-full md:w-[300px] h-1.5"
}

import { inject, onMounted, useTemplateRef, watch } from 'vue';
import Button from '../base/Button.vue';
import { useCssVar } from '@vueuse/core';
import { useRouter } from 'vue-router';
import { useGettext } from 'vue3-gettext';
import { useTokensStore } from '~src/admin/stores/useTokensStore';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'PostsLimit',
  setup(__props) {

const { $gettext } = useGettext();

// Router
const router = useRouter();

// Get tokens store
const { totalTokens, usedTokens, totalTokensAdditional, refreshTokens } = useTokensStore();

// Get tokens from config
const usedArticles = usedTokens;
const totalArticles = totalTokens;
const totalArticlesAdditional = totalTokensAdditional;

// Progress bar element
const progressBar = useTemplateRef('progress-bar');

// Progress bar calculation and update function
const updateProgressBar = () => {
	const useArticles = usedArticles.value;
    const progressBarPercentage = (useArticles / totalArticles.value) * 100;

    // Set progress bar width
    const progressWidth = useCssVar('--progressWidth', progressBar.value);
    progressWidth.value = `${progressBarPercentage}%`;

    // Set progress bar color
    const progressColor = useCssVar('--progressColor', progressBar.value);

    if (progressBarPercentage < 50) {
        progressColor.value = '#79D22C';
    } else if (progressBarPercentage >= 50 && progressBarPercentage < 75) {
        progressColor.value = '#FFDB21';
    } else {
        progressColor.value = '#FF3221';
    }
};

// Initial progress bar setup
updateProgressBar();

// Watch for refreshTokens changes
watch(
    () => refreshTokens.value,
    () => {
        updateProgressBar();
    }
);

// Account type
const isAccountFree = inject('isAccountFree');

// Account expired
const isAccountExpired = inject<boolean>('isAccountExpired');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_unref($gettext)('Used')) + " " + _toDisplayString(_unref(usedArticles)) + " " + _toDisplayString(_unref($gettext)('out of')) + " " + _toDisplayString(_unref(totalArticles)) + " " + _toDisplayString(_unref(isAccountFree) ? _unref($gettext)('weekly token.') : _unref($gettext)('weekly tokens.')) + "   ", 1),
      (_unref(totalArticlesAdditional))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref($gettext)('You have')) + " " + _toDisplayString(_unref(totalArticlesAdditional)) + " " + _toDisplayString(_unref($gettext)('additional tokens left.')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("span", _hoisted_4, null, 512),
    (_unref(isAccountFree))
      ? (_openBlock(), _createBlock(Button, {
          key: 0,
          text: _unref($gettext)('Upgrade'),
          size: "small",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).push('/upgrade')), ["prevent"]))
        }, null, 8, ["text"]))
      : (_openBlock(), _createBlock(Button, {
          key: 1,
          disabled: _unref(isAccountExpired),
          text: _unref($gettext)('Add more'),
          size: "small",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(router).push('/add-articles')), ["prevent"]))
        }, null, 8, ["disabled", "text"]))
  ]))
}
}

})